<script setup>

</script>

<template>
  <SubContentHeader centered>Nasza oferta łączy najlepsze cechy finansowania samochodu</SubContentHeader>
  <ContentLeasingFeaturesTable class="mt-6"/>
</template>
